$(document).ready(function () {
  document.querySelectorAll(".bonus-code-text").forEach((container) => {
    textToggle = container.querySelector(".bonus-code-text-toggle");
    input = container.querySelector(".bonus-code-text-input");

    textToggle.addEventListener("click", (e) => {
      textToggle.classList.add("d-none");
      input.classList.remove("d-none");
      input.focus();
    });

    if (!!input.value) {
      textToggle.classList.add("d-none");
      input.classList.remove("d-none");
    }
  });
});
